import { useEffect } from 'react'

import { setCustomMapStyle } from '@/features/domain/ui'
import { useAppDispatch } from '@/store'

export function useHideGeofenceWhileEditing(editing: boolean, geofenceId?: string) {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!geofenceId || !editing) return

    // hide the feature
    dispatch(
      setCustomMapStyle({
        customStyle: {
          type: 'geofence',
          mode: 'off',
          ids: [geofenceId],
        },
      }),
    )

    return () => {
      dispatch(
        setCustomMapStyle({
          customStyle: {
            type: 'geofence',
            mode: 'on',
            ids: [geofenceId],
          },
        }),
      )
    }
  }, [dispatch, editing, geofenceId])
}
